<div class="input-wrap select">
  <select
    class="input"
    [disabled]="isLoading"
    [(ngModel)]="value"
    (ngModelChange)="onValueChanged()"
  >
    <option [value]="''" [hidden]="required" selected="selected">
      {{ placeholder }}
    </option>

    <option *ngFor="let state of states$ | async" [value]="state.code">
      {{ state.code }}
    </option>
  </select>
</div>
